import { MapType } from '../MapType'

/**
 * Encapsulates parameters used to make requests to [MapService].
 */
export class FramesByMapTypeRequest {
  /**
   * Gets or sets the map type.
   */
  public mapType: MapType

  /**
   * Gets or sets whether to ensure the response is not stale/cached.
   * Defaults to false, meaning a cached result will be returned if available.
   */
  public refreshCache = false

  /**
   * Initializes a new [FramesByMapTypeRequest].
   * @param mapType The map type.
   */
  constructor(mapType: MapType) {
    this.mapType = mapType
  }
}
